/**
 * fromクエリパラメータがwidget_で始まるリクエストの時のみ、ログを送信する
 * 他のjsによりすぐにfromクエリパラメータが書き換わるのと、js側でも1回のみ送信するためのフラグを持つ
 * from_widget_log_urlはshow_for_widgetアクションのみで設定される
 * fromクエリパラメータがwidget_から始まっているかここでも確認しているのでURLが書き換えられる前にインスタンス化すること
 */
class LoggerForShowForWidget {
  constructor(logUrl) {
    this.alreadySentLog = true
    this.logUrl = logUrl
    this.checkFromQueryParameter()
  }

  checkFromQueryParameter() {
    if (this.logUrl === undefined || this.logUrl === null) return

    const searchParams = new URLSearchParams(window.location.search)
    const fromParam = searchParams.get('from')
    if (fromParam !== null && fromParam.startsWith('widget_')) {
      this.alreadySentLog = false
    }
  }

  sendLog() {
    if (this.alreadySentLog) return

    this.alreadySentLog = true
    $.get(this.logUrl)
  }
}

export default LoggerForShowForWidget;
